import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

function Home() {
  const theme = useTheme();

  const isLight = theme.palette.type === 'light';
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.homeWrapper}>
      <div className={styles.home}>
        <div className={styles.logoContainer}>
          {/* Here the backdrop really is the page, so the lockup follows the
              theme: dark ink on the white page, light ink on the dark one.
              The asset already contains the "TCG Scout" wordmark. */}
          <img
            className={styles.logoLockup}
            src={isLight ? '/logo-lockup-light.png' : '/logo-lockup-dark.png'}
            alt="TCG Scout"
          />
        </div>
        <div className={styles.homeLink}>
          <a href="/login">{t('login.links.home')}</a>
        </div>
      </div>
    </div>
  );
}

export default Home;
